export const API_URL = 'https://api.turboleads.nl/admin';
export const INACTIVITY_TIME = 120;